module.exports = __webpack_public_path__ + "static/media/zhuxuejun.ad87fcf5.png";